import { db } from "../../firebase";
import { doc, updateDoc } from "firebase/firestore";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const AddCustomUnit = async (newUnitsArray) => {
  try {
    const PropertyDynamicFieldsDoc = await doc(
      db,
      "clients",
      getLocalStorageItem("bid"),
      "dynamicFields",
      "property"
    );

    let dataToUpdate = {};
    dataToUpdate[`landUnits`] = newUnitsArray;
    await updateDoc(PropertyDynamicFieldsDoc, dataToUpdate);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default AddCustomUnit;
